export default __webpack_public_path__ + "static/media/bg25.b22846c7.jpg";